import API_BASE from "../config";
import authHeader from "./auth-header";
import axios from "axios";

const API_URL = API_BASE + "/api/cart";

// All cart calls are authenticated; the server scopes the cart to the token user.
const get = () => axios.get(API_URL, { headers: authHeader() });

const addItem = (product_id, quantity = 1) =>
  axios.post(`${API_URL}/items`, { product_id, quantity }, { headers: authHeader() });

const updateItem = (itemId, quantity) =>
  axios.put(`${API_URL}/items/${itemId}`, { quantity }, { headers: authHeader() });

const removeItem = (itemId) =>
  axios.delete(`${API_URL}/items/${itemId}`, { headers: authHeader() });

const clear = () => axios.delete(API_URL, { headers: authHeader() });

const CartService = { get, addItem, updateItem, removeItem, clear };

export default CartService;
